import { NgModule } from '@angular/core';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { ShopComponent } from './shop.component';
import { TranslateModule } from '@ngx-translate/core';
import { ShopDetailComponent } from './shop-detail.component';
import { dynamicStateConfigFn, Ng2DynamicStateDeclaration } from '@ngx-ivengi/locale';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'shop',
    future: true,
    component: ShopComponent,
    // url: '/?search&dealer&type&kleur&materiaal&model&prijs&afstand&land&postcode&pagina&sort',
  },
  {
    name: 'shop.detail',
    future: true,
    component: ShopDetailComponent,
    // url: 'product/:productID',
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn,
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})

export class ShopRoutes {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/components/shop/shop.routes.ts